__turbopack_context__.v({
  "beat": "ScienceOpening-module___ti1fq__beat",
  "ctas": "ScienceOpening-module___ti1fq__ctas",
  "eyebrow": "ScienceOpening-module___ti1fq__eyebrow",
  "glLayer": "ScienceOpening-module___ti1fq__glLayer",
  "gridFx": "ScienceOpening-module___ti1fq__gridFx",
  "h1": "ScienceOpening-module___ti1fq__h1",
  "hintBob": "ScienceOpening-module___ti1fq__hintBob",
  "scrollHint": "ScienceOpening-module___ti1fq__scrollHint",
  "scrub": "ScienceOpening-module___ti1fq__scrub",
  "sticky": "ScienceOpening-module___ti1fq__sticky",
  "sub": "ScienceOpening-module___ti1fq__sub",
  "track": "ScienceOpening-module___ti1fq__track",
  "under": "ScienceOpening-module___ti1fq__under",
});
